import React, { useContext } from "react";
import css from "../Modulecss/Home.module.css";
import { Link } from "react-router-dom";
import Header from "../Components/Header";
import { LanguageContext } from "../Components/LanguageContext";
import { useTheme } from "../../ThemeContext";
import { colors } from "@mui/material";

export default function RunningCard({ runnig, winnAmount, game_type }) {
  const user = localStorage.getItem("userId");
  // console.log(user,"running")

  // language
  const translations = {
    hi: {
      view: "देखे",
      prize: "इनाम",
      entry: "प्रवेश शुल्क",
    },
    en: {
      view: "view",
      entry: "Entry Fee ",
      prize: "Winning Prize",
    },
  };

  const { language } = useContext(LanguageContext);

  // change theme
  const theme = localStorage.getItem('theme')

  const styles = {
    color: theme === "light" ? "black" : "black",
  };

  return (
    <>
      <div className="rb_gold_card">

        <div className="rb_gold_top">

          <span className="rb_gold_heading">
            Playing For
          </span>
          <div className="rb_gold_name_main">
            <span className="rb_gold_name">
              {runnig.Created_by.Name.length > 5
                ? `${runnig.Created_by.Name.slice(0, 5)}...`
                : runnig.Created_by.Name}

            </span>

            <span className="rb_gold_and">
              &
            </span>

            <span className="rb_gold_name">
              {runnig.Accepetd_By.Name.length > 5
                ? `${runnig.Accepetd_By.Name.slice(0, 5)}...`
                : runnig.Accepetd_By.Name}
            </span>

          </div>
        </div>

        <div className="rb_gold_bottom">

          {/* Entry */}
          <div className="rb_gold_amount_box">

            <span className="rb_gold_label">
              {translations[language].entry}
            </span>

            <div className="rb_gold_amount">

              <img
                src="/images/moneyrupee.png"
                alt=""
                width="18"
                height="18"
              />

              <span>
                {runnig.Game_Ammount}
              </span>

            </div>

          </div>

          {/* Center */}
          <div className="rb_gold_center">

            {user == runnig.Accepetd_By._id ||
              user == runnig.Created_by._id ? (

              <Link
                className={`rb_gold_view_btn ${runnig.Status === "conflict"
                  ? "rb_gold_conflict"
                  : ""
                  }`}
                to={{
                  pathname: `/viewgame1/${runnig._id}`,
                  state: { prevPath: window.location.pathname },
                }}
              >
                {translations[language].view}
              </Link>

            ) : (

              <img
                className="rb_gold_vs"
                src="../images/VS-image.png"
                alt=""
              />

            )}

          </div>

          {/* Prize */}
          <div className="rb_gold_amount_box">

            <span className="rb_gold_label">
              {translations[language].prize}
            </span>

            <div className="rb_gold_amount">

              <img
                src="/images/moneyrupee.png"
                alt=""
                width="18"
                height="18"
              />

              <span>
                {runnig.Game_Ammount +
                  winnAmount(runnig.Game_Ammount)}
              </span>

            </div>

          </div>

        </div>

      </div>
    </>
  );
}
